import "./SearchFilter.css";
import React from "react";
import PropTypes from "prop-types";
import { observer, PropTypes as MobxPropTypes } from "mobx-react";
import { observable } from "mobx";
import CustomForm from "gradifui/components/form/CustomForm";
import CustomInput from "gradifui/components/form/CustomInput";
import autobind from "autobind-decorator";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import isFunction from "lodash/isFunction";
import Propulator from "higher-order/Propulator";

@observer
class SearchFilter extends React.Component {
    @observable isFocused = false;

    static propTypes = {
        filterModel: MobxPropTypes.objectOrObservableObject.isRequired,
        dispatcher: MobxPropTypes.objectOrObservableObject.isRequired,
        disableUntilTableModelLoaded: PropTypes.bool
    };

    @autobind
    handleSearchSubmit(e) {
        if (this.props.tableModel) {
            this.props.tableModel.updateFilter(this.props.filterModel.key, this.props.filterModel.searchValue, this.props.dispatcher);
        }

        if (isFunction(this.props.onSubmit)) {
            this.props.onSubmit(e);
        }
        this.isFocused = false;
        e.preventDefault(); // prevent cancel button from receiving event
    }

    @autobind
    handleFocus(e) {
        this.isFocused = true;
    }

    @autobind
    handleSearchClear(e) {
        if (this.props.tableModel) {
            this.props.tableModel.updateFilter(this.props.filterModel.key, "", this.props.dispatcher);
        }

        if (isFunction(this.props.onClear)) {
            this.props.onClear(e);
        }
    }

    render() {
        const inputClasses = classNames("search-input", {
            "has-value": !isEmpty(this.props.filterModel.value),
            "has-focus": this.isFocused
        });

        return (
            <CustomForm form={this.props.filterModel.searchForm} className="search-filter" showFormLevelErrors={false}>
                <CustomInput fieldName="searchValue" className={inputClasses} placeholder={this.props.filterModel.placeholder || "Search..."}
                    onFocus={this.handleFocus}
                    onBlur={this.handleSearchSubmit}
                    autoComplete="off"
                    inputDisabled={this.props.disableUntilTableModelLoaded && this.props.tableModel && !this.props.tableModel.isLoaded}
                />
                {!isEmpty(this.props.filterModel.value) &&
                    <button className="search-clear" title="Clear search" onClick={this.handleSearchClear}><i className="icon-cancel" /></button>
                }
                {isEmpty(this.props.filterModel.value) &&
                    <button type="submit" title="Search" className="search-submit"><i className="icon-search" /></button>
                }
            </CustomForm>
        );
    }
}

export default Propulator(SearchFilter, {});
